import type { ThemeMode } from '@app/types';

export const THEME_STORAGE_KEY = 'theme';
export const DEFAULT_THEME: ThemeMode = 'dark';
export const MAINTENANCE_IMAGE_URL =
  'https://storage.yandexcloud.net/site-assets/under_maintanance.png';
export const CARD_WIDTH = '400px';
